<template>
  <div>
    <section class="member-box">
      <div class="container">
        <div class="box" v-if="!validOld">
          <h1>{{ $t("舊會員登入") }}</h1>
          <hr />
          <div class="form-group">
            <label for="cardNo">{{ $t("卡片號碼") }}</label>
            <input type="text" class="form-control" id="cardNo" v-model="cardNo" maxlength="20" />
          </div>
          <div class="form-group">
            <label for="ident">{{ $t("身分證字號") }}</label>
            <input type="password" class="form-control" id="ident" v-model="ident" maxlength="20" />
          </div>
          <div class="btn-box">
            <button @click="handleCheck">{{ $t("驗證") }}</button>
          </div>
        </div>
        <div class="box" v-if="validOld">
          <h1>{{ $t("新會員資訊") }}</h1>
          <hr />
          <div class="form-group" style="position: relative">
            <label for="formGroupExampleInput">{{ $t("手機號碼") }}</label>
            <div class="phone">
              <vue-tel-input @input="onInput"></vue-tel-input>
            </div>
            <span id="showPhone" @click="viewphone = !viewphone"><img
                :src="viewphone ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
          </div>
          <div class="btn-box" v-if="!issned">
            <button @click="getPinCode">{{ $t("獲取驗證碼") }}</button>
          </div>
          <div class="form-group" v-if="issned && !pincodeCheck">
            <label for="inputCode">{{ $t("手機驗證碼") }}</label>
            <input :placeholder="$t('請輸入手機簡訊驗證碼')" type="text" class="form-control" id="inputCode"
              v-model="pincode_input" />
          </div>
          <div class="btn-box" v-if="issned && !pincodeCheck">
            <button @click="checkPinCode">{{ $t("驗證") }}</button>
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="password">{{ $t("新密碼") }}</label>
            <input :placeholder="$t('請輸入您想設定的新密碼')" :type="viewpassword ? 'text' : 'password'" class="form-control"
              id="password" v-model="password" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="passwordConfirm">{{ $t("確認密碼") }}</label>
            <input :placeholder="$t('請再次輸入您想設定的密碼')" :type="viewpasswordConfirm ? 'text' : 'password'"
              class="form-control" id="passwordConfirm" v-model="passwordConfirm" />
          </div>
          <hr v-if="pincodeCheck" />
          <div class="form-group" v-if="pincodeCheck">
            <label for="city">{{ $t("縣市") }}</label>
            <select class="form-control" id="city">
              <option v-for="City in Citys" :key="City.o_maas_city_seq" :value="City.o_maas_city_seq">
                {{
                  local == "en"
                    ? City.o_maas_city_name_en
                    : City.o_maas_city_name_zh_tw
                }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="town">{{ $t("鄉鎮區") }}</label>
            <select class="form-control" id="town">
              <option v-for="Town in Towns" :key="Town.o_maas_town_seq" :value="Town.o_maas_town_seq">
                {{
                  local == "en"
                    ? Town.o_maas_town_name_en
                    : Town.o_maas_town_name_zh_tw
                }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="pincodeCheck" style="display: none">
            <label for="address">{{ $t("地址") }}</label>
            <input :placeholder="$t('請輸入地址(選填)')" type="text" class="form-control" id="address" v-model="address" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="taxID">{{ $t("統一編號") }}</label>
            <input :placeholder="$t('請輸入統一編號(選填)')" type="text" class="form-control" id="taxID" v-model="taxID" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="school">{{ $t("學校名稱") }}</label>
            <input :placeholder="$t('請輸入學校名稱(選填)')" type="text" class="form-control" id="school" v-model="school" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="email">{{ $t("電子信箱") }}</label>
            <input :placeholder="$t('請輸入電子信箱(選填)')" type="text" class="form-control" id="email" v-model="email" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="gender">{{ $t("性別") }}</label>
            <select class="form-control" id="gender" v-model="gender">
              <option value="" selected>{{ $t("未設定") }}</option>
              <option value="M">{{ $t("男性") }}</option>
              <option value="F">{{ $t("女性") }}</option>
            </select>
          </div>
          <div class="question-box" v-if="pincodeCheck">
            <p>
              {{ $t("親愛的用戶您好，") }}
              {{
                $t(
                  "感謝您使用「MeN Go」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？"
                )
              }}
            </p>
            <div class="form-group">
              <label for="userOfPT">{{ $t("是否為大眾運輸的使用者？") }}</label>
              <select class="form-control" id="userOfPT">
                <option value="是" selected>{{ $t("是") }}</option>
                <option value="否">{{ $t("否") }}</option>
              </select>
            </div>
            <div id="divTypeA" class="form-group">
              <label for="transportTypeA">{{
                $t("主要使用的交通工具是？")
              }}</label>
              <select class="form-control" id="transportTypeA">
                <option value="捷運" selected>{{ $t("捷運") }}</option>
                <option value="輕軌">{{ $t("輕軌") }}</option>
                <option value="公車">{{ $t("公車") }}</option>
                <option value="台鐵">{{ $t("台鐵") }}</option>
                <option value="渡輪">{{ $t("渡輪") }}</option>
                <option value="交通車">{{ $t("交通車") }}</option>
              </select>
            </div>
            <div id="divTypeB" class="form-group" style="display: none">
              <label for="transportTypeB">{{
                $t("主要使用的交通工具是？")
              }}</label>
              <select class="form-control" id="transportTypeB">
                <option value="汽車" selected>{{ $t("汽車") }}</option>
                <option value="機車">{{ $t("機車") }}</option>
                <option value="自行車">{{ $t("自行車") }}</option>
                <option value="其他">{{ $t("其他") }}</option>
              </select>
            </div>
          </div>
          <div class="btn-box" v-if="pincodeCheck">
            <button @click="handleOldLogin">{{ $t("送出") }}</button>
          </div>
          <router-link :to="{ name: 'Login' }" class="note mt-3" v-if="!issned">{{ $t("返回登入") }}</router-link>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "舊會員登入": "舊會員登入",
    "卡片號碼": "卡片號碼",
    "身分證字號": "身分證字號",
    "驗證": "驗證",
    "新會員資訊": "新會員資訊",
    "手機號碼": "手機號碼",
    "獲取驗證碼": "獲取驗證碼",
    "手機認證碼": "手機認證碼",
    "請輸入手機簡訊認證碼": "請輸入手機簡訊認證碼",
    "新密碼": "新密碼",
    "請輸入您想設定的新密碼": "請輸入您想設定的新密碼",
    "確認密碼": "確認密碼",
    "請再次輸入您想設定的密碼": "請再次輸入您想設定的密碼",
    "親愛的用戶您好，": "親愛的用戶您好，",
    "感謝您使用「MeNGo」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？": "感謝您使用「MeNGo」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？",
    "是否為大眾運輸的使用者？": "是否為大眾運輸的使用者？",
    "是": "是",
    "否": "否",
    "主要使用的交通工具是？": "主要使用的交通工具是？",
    "捷運": "捷運",
    "輕軌": "輕軌",
    "公車": "公車",
    "台鐵": "台鐵",
    "渡輪": "渡輪",
    "交通車": "交通車",
    "汽車": "汽車",
    "機車": "機車",
    "自行車": "自行車",
    "其他": "其他",
    "送出": "送出",
    "返回登入": "返回登入",
    "錯誤": "錯誤",
    "確定": "確定",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "密碼與確認密碼不符合, 請確認後再試一次": "密碼與確認密碼不符合, 請確認後再試一次",
    "註冊成功": "註冊成功",
    "即將前往登入頁面": "即將前往登入頁面",
  },
  en: {
    "舊會員登入": "Old member log in",
    "卡片號碼": "Card number",
    "身分證字號": "ID No.",
    "驗證": "Verify",
    "新會員資訊": "New member info",
    "手機號碼": "Mobile number",
    "獲取驗證碼": "Get the verification code",
    "手機認證碼": "Mobile verification code",
    "請輸入手機簡訊認證碼": "Please enter the verification code",
    "新密碼": "New password",
    "請輸入您想設定的新密碼": "Please enter the new password you want to set",
    "確認密碼": "Confirm the password",
    "請再次輸入您想設定的密碼": "Please enter the new password you want to set again",
    "親愛的用戶您好，": "Dear users,",
    "感謝您使用「MeNGo」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？": "Thank you for using MeN Go. Before registering for the first time, we would like to know if you are a user of public transport (more than 5 times per week on public transport).",
    "是否為大眾運輸的使用者？": "Are you a user of public transport?",
    "是": "Yes",
    "否": "No",
    "主要使用的交通工具是？": "What are your main ways of transportation?",
    "捷運": "MRT",
    "輕軌": "Light rail",
    "公車": "Bus",
    "台鐵": "Railway",
    "渡輪": "Ferry",
    "交通車": "Shuttle bus",
    "汽車": "Automobile",
    "機車": "Motorcycle",
    "自行車": "Bike",
    "其他": "Others",
    "送出": "Send",
    "返回登入": "Back",
    "錯誤": "Error",
    "確定": "Confirm",
    "手機號碼格式錯誤": "Wrong mobile number format",
    "密碼與確認密碼不符合, 請確認後再試一次": "Please confirm the password and try again.",
    "註冊成功": "Done",
    "即將前往登入頁面": "Will go to the login page",
  },
  jp: {
    "舊會員登入": "舊會員登入",
    "卡片號碼": "卡片號碼",
    "身分證字號": "身分證字號",
    "驗證": "驗證",
    "新會員資訊": "新會員資訊",
    "手機號碼": "手機號碼",
    "獲取驗證碼": "獲取驗證碼",
    "手機認證碼": "手機認證碼",
    "請輸入手機簡訊認證碼": "請輸入手機簡訊認證碼",
    "新密碼": "新密碼",
    "請輸入您想設定的新密碼": "請輸入您想設定的新密碼",
    "確認密碼": "確認密碼",
    "請再次輸入您想設定的密碼": "請再次輸入您想設定的密碼",
    "親愛的用戶您好，": "親愛的用戶您好，",
    "感謝您使用「MeNGo」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？": "感謝您使用「MeNGo」服務，首次註冊之前，我們想了解您是否為大眾運輸的使用者(每週搭乘大眾運輸的次數達5次以上)？",
    "是否為大眾運輸的使用者？": "是否為大眾運輸的使用者？",
    "是": "是",
    "否": "否",
    "主要使用的交通工具是？": "主要使用的交通工具是？",
    "捷運": "捷運",
    "輕軌": "輕軌",
    "公車": "公車",
    "台鐵": "台鐵",
    "渡輪": "渡輪",
    "交通車": "交通車",
    "汽車": "汽車",
    "機車": "機車",
    "自行車": "自行車",
    "其他": "其他",
    "送出": "送出",
    "返回登入": "返回登入",
    "錯誤": "錯誤",
    "確定": "確定",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "密碼與確認密碼不符合, 請確認後再試一次": "密碼與確認密碼不符合, 請確認後再試一次",
    "註冊成功": "註冊成功",
    "即將前往登入頁面": "即將前往登入頁面",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Login",
  i18n,
  data() {
    return {
      cardNo: "",
      ident: "",
      validOld: false,
      issned: false,
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      countryCallingCode: "",
      number: "",
      valid: false,
      password: "",
      passwordConfirm: "",
      vtiProps: {
        disabled: false,
      },
      viewpassword: false,
      viewpasswordConfirm: false,
      Citys: [],
      Towns: [],
      address: "",
      taxID: "",
      school: "",
      email: "",
      local: "zh_tw",
      gender: "",
      viewphone: false,
      SMSCheckNumber: "",
    };
  },
  watch: {
    cardNo(newValue, oldValue) {
      var rules = new RegExp(/[^0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.cardNo = newValue.replace(rules, '');
        })
      }
    },
    ident(newValue, oldValue) {
      var rules = new RegExp(/[^A-Z0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.ident = newValue.replace(rules, '');
        })
      }
    },
    viewphone(newValue, oldValue) {
      if (newValue) {
        $(".vti__input").addClass("show_phone");
      } else {
        $(".vti__input").removeClass("show_phone");
      }
    },
  },
  created: function () {
    let that = this;
    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
        this.GLOBAL.subDirectory +
        "/Htmlv2/GetCityAndTown",
        {
          params: {},
        }
      )
      .then((response) => {
        this.Citys = response.data.Citys;
        this.Towns = response.data.Towns;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套Class
    $(".wrapper").addClass("member-singin");
    $(".wrapper").addClass("member-singin-old");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {
    $("#userOfPT").on("change", function () {
      var value = $(this).find("option:selected").val();
      if (value == "是") {
        $("#divTypeA").show();
        $("#divTypeB").hide();
      } else {
        $("#divTypeA").hide();
        $("#divTypeB").show();
      }
    });

    let that = this;

    $("#city").on("change", function () {
      var o_maas_town_city_seq = $(this).find("option:selected").val();
      $.ajax({
        type: "post",
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/GetTown",
        data: {
          o_maas_town_city_seq: o_maas_town_city_seq,
        },
        success: function (result) {
          $("#town").find("option").remove();
          var data = jQuery.parseJSON(result.items);
          $.each(data, function (i, item) {
            $("#town").append(
              '<option value="' + item.id + '">' + item.text + "</option>"
            );
          });
          $("#town").val($("#town option:first").val());
        },
      });
    });
  },
  methods: {
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    handleCheck() {
      let cardNo = this.cardNo;
      let ident = this.ident;
      let token = AES.encrypt(cardNo + "|" + ident);
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/OldLoginCheck",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.validOld = true;
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    getPinCode() {
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let cardNo = this.cardNo;
        let ident = this.ident;
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        let ipaddress = this.ipaddress;
        // 組合並送出
        let token = AES.encrypt(
          cardNo + "|" + ident + "|" + countryCallingCode + "|" + number
        );
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/OldLoginCheckNumber",
          type: "post",
          data: {
            token: token,
          },
          dataType: "json",
          error: function () { },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.vtiProps.disabled = true;
              that.issned = true;
              that.SMSCheckNumber = res.SMSCheckNumber;
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          },
        });
      }
    },
    checkPinCode() {
      if (!this.pincode_input) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入正確的驗證碼"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      // 組合並送出
      let token = AES.encrypt(this.SMSCheckNumber + "|" + this.pincode_input);
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/PhoneVerify",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.pincodeCheck = true;
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
            that.issned = false;
            that.pincode_input = "";
            that.pincodeCheck = false;
          }
        },
      });
    },
    handleOldLogin() {
      let cardNo = this.cardNo;
      let ident = this.ident;
      let countryCallingCode =
        this.countryCallingCode == null ? "" : this.countryCallingCode;
      let number = this.number == null ? "" : this.number;
      let password = this.password;
      let passwordConfirm = this.passwordConfirm;
      if (password != passwordConfirm) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("密碼與確認密碼不符合, 請確認後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      if (this.email != "" && !this.validateEmail(this.email)) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("請輸入一個正確的電子郵件地址"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        this.sending = false;
        return;
      }
      let token = AES.encrypt(
        cardNo +
        "|" +
        ident +
        "|" +
        countryCallingCode +
        "|" +
        number +
        "|" +
        password +
        "|" +
        passwordConfirm +
        "|" +
        $("#city").val() +
        "|" +
        $("#town").val() +
        "|" +
        this.address +
        "|" +
        this.taxID +
        "|" +
        this.school +
        "|" +
        this.email +
        "|" +
        this.gender
      );
      let that = this;
      let transportType = "";
      if ($("#userOfPT").val() == "是") {
        transportType = $("#transportTypeA").val();
      } else {
        transportType = $("#transportTypeB").val();
      }
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/OldLogin",
        type: "post",
        data: {
          token: token,
          userOfPT: $("#userOfPT").val(),
          transportType: transportType,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("註冊成功"),
              text: that.$t("即將前往登入頁面"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                // 轉到首頁
                that.$router.push("/Login");
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
    validateEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member-box .form-group .phone {
  border: none;
}

.vue-tel-input {
  width: 100%;
}

#showPhone {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/OldLogin.vue